import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import type { ComponentProps } from 'react';

import Button from 'Components/UI_Library/FormElements/Button';
import CloseBtn from 'Components/UI_Library/Icons/CloseBtn';
import { ReactComponent as PaytronLogo } from 'Components/UI_Library/Icons/Paytron.svg';
import classes from './NotificationUpdate.module.css';
import { getIcon } from '../getIcon';

type Props = {
    notification: {
        type?: 'danger' | 'success' | 'warning' | 'info';
        message: string;
        action?: {
            text: string;
            url: string;
        };

        forceRedirect?: string;
    };
    onClose?: () => void;
};

/** @deprecated NotificationUpdate is just used for subscription notifications. It should not be further used and preferably removed */
const NotificationUpdate = (props: Props) => {
    const history = useNavigate();
    const { notification } = props;

    useEffect(() => {
        if (notification.forceRedirect) {
            history(notification.forceRedirect);
        }
    }, []);

    return (
        <div className={classes.wrapper}>
            <div className={classes.container}>
                <div className={classes.paytronUpdates}>
                    <PaytronLogo fill="#FFFFFF" /> <span>Updates</span>
                </div>
                <div className={classes.notificationMessage}>
                    {notification.type && <img src={getIcon(notification.type)} alt="notification-icon" />}
                    <span>{notification.message}</span>
                    {notification.action && (
                        <Button
                            type={notification.type as ComponentProps<typeof Button>['type']}
                            text={notification.action.text}
                            href={notification.action.url}
                        />
                    )}
                    {props.onClose && (
                        <div className={classes.notificationClose}>
                            <CloseBtn colour="#ffffff" onClick={() => props.onClose?.()} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NotificationUpdate;
